export default {
    'CreateTime': '创建时间：',
    'OK': '确定',
    'NoItems': '暂无选项，请去后台管理配置',
    'Processing': '进行中',
    'Completed': '已完成',
    'Cancled': '已作废',
    'Draft': '草稿',
    'Filter': '筛选',
    'NoFilterTip': '后台暂未配置筛选项',
    'SequenceStatus': '单据状态',
    'NoPermissionAdd': '您没有发起流程的权限',
};
